// Simple, convincing confetti burst using a fullscreen canvas.
// Call fireConfetti() to celebrate 🎉
export function fireConfetti(options = {}) {
  const {
    particleCount = 180,
    spread = Math.PI / 2, // radiation angle width (in radians)
    startVelocity = 12, // base speed
    decay = 0.01, // how quickly particles fade
    gravity = 4, // downward pull
    origin = { x: 0.5, y: 0.3 }, // where on screen [0..1, 0..1]
  } = options;

  // Create canvas overlay
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.style.position = "fixed";
  canvas.style.inset = "0";
  canvas.style.pointerEvents = "none";
  canvas.style.zIndex = "9999";
  document.body.appendChild(canvas);

  let width = (canvas.width = window.innerWidth);
  let height = (canvas.height = window.innerHeight);

  function onResize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  }
  window.addEventListener("resize", onResize);

  const colors = [
    "#FF5252",
    "#FFEB3B",
    "#4CAF50",
    "#03A9F4",
    "#FF9800",
    "#E91E63",
    "#9C27B0",
  ];

  // Create particles
  const particles = [];
  const centerX = origin.x * width;
  const centerY = origin.y * height;

  for (let i = 0; i < particleCount; i++) {
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * spread;
    const speed = startVelocity * (0.5 + Math.random() * 0.8);

    particles.push({
      x: centerX,
      y: centerY,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      size: 5 + Math.random() * 6,
      color: colors[Math.floor(Math.random() * colors.length)],
      rotation: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.3,
      life: 1, // 1 → 0
      decay: decay * (0.8 + Math.random() * 0.4), // slightly varied decay
      tilt: (Math.random() - 0.5) * 0.7, // little wobble
    });
  }

  let animationFrameId;

  function update() {
    ctx.clearRect(0, 0, width, height);

    let alive = 0;
    for (const p of particles) {
      if (p.life <= 0) continue;

      // Physics
      p.vy += gravity * 0.1; // small gravity each frame
      p.x += p.vx;
      p.y += p.vy;
      p.rotation += p.spin;
      p.life -= p.decay;

      if (p.life <= 0) continue;
      alive++;

      // Draw
      ctx.save();
      ctx.globalAlpha = Math.max(p.life, 0);
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rotation + p.tilt * Math.sin((1 - p.life) * 10));
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.4);
      ctx.restore();
    }

    if (alive > 0) {
      animationFrameId = requestAnimationFrame(update);
    } else {
      // Clean up when done
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", onResize);
      canvas.remove();
    }
  }

  update();
}
